import { render, staticRenderFns } from "./SavedPlanUnitCardErrors.vue?vue&type=template&id=2f105940&"
import script from "./SavedPlanUnitCardErrors.vue?vue&type=script&lang=js&"
export * from "./SavedPlanUnitCardErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports